import React from "react";

interface ScannedCardsPendingProps {
  count: number;
}

/**
 * SGL-346: the drafting step, shown in the thread.
 *
 * The capture panel used to hold its own spinner open across both the extract and
 * the drafting call, so a stack of cards meant staring at a modal for the length of
 * N model calls. The panel now closes as soon as the cards are read and this takes
 * over, next to the agent doing the work.
 *
 * There is deliberately no "2 of 3" progress here: drafting is a single request, so
 * a per-contact counter would be invented. The two steps below are both true — the
 * cards really are read by the time this renders.
 */
export const ScannedCardsPending: React.FC<ScannedCardsPendingProps> = ({ count }) => (
  <div className="my-1 w-full max-w-[340px] overflow-hidden rounded-2xl border border-theme-border bg-theme-surface px-4 py-3.5">
    <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.12em] text-theme-fg-muted">
      Working
    </p>

    <div className="mb-2.5 flex items-center gap-2.5">
      <span
        className="material-icons-outlined text-[16px]"
        style={{ color: "var(--color-primary)" }}
      >
        check
      </span>
      <span className="text-[13px] text-theme-fg">
        Read {count} card{count === 1 ? "" : "s"}
      </span>
    </div>

    <div className="flex items-center gap-2.5">
      <span
        className="h-[15px] w-[15px] flex-shrink-0 animate-spin rounded-full border-2 border-theme-border"
        style={{ borderTopColor: "var(--color-primary)" }}
        aria-hidden="true"
      />
      <span className="text-[13px] font-semibold text-theme-fg">
        Writing intro emails&hellip;
      </span>
    </div>

    <p className="mt-3 text-[11px] text-theme-fg-muted">
      Nothing is saved or sent while I draft.
    </p>
  </div>
);

export default ScannedCardsPending;
